import React from 'react';
import Image from 'next/image';
import './ProcessCard.scss';

interface ProcessCardProps {
  image: string;
  title: string;
  description: string;
}

const ProcessCard: React.FC<ProcessCardProps> = ({ image, title, description }) => {
  return (
    <div className="process-card">
      <Image
        src={image}
        alt="Advocacy step"
        width={80}
        height={80}
        className="process-card__image"
      />
      <div className="process-card__content">
        <span className="process-card__title">{title}</span>
        <p className="process-card__description">{description}</p>
      </div>
    </div>
  );
};

export default ProcessCard;
